import { useExperiments } from '@wix/fe-essentials/react';
import { useAtomValue } from 'jotai';
import { useCallback } from 'react';
import { crossPageColorContrastIssuesAtom } from '../../atoms/session-atoms';
import { getSpecificPageIssueResults } from './get-specific-page-issue-result';
export const useBuildSpecificPageIssueResults = () => {
  const crossPageColorContrastIssuesInSession = useAtomValue(crossPageColorContrastIssuesAtom);
  const {
    experiments
  } = useExperiments();
  const isMediaAltCross = experiments.enabled('specs.a11y-wizard.MediaAltToCross');
  return useCallback(_ref => {
    let {
      executionResults,
      crossPageIssues,
      pageId
    } = _ref;
    const specificPageResults = getSpecificPageIssueResults(executionResults, crossPageIssues, crossPageColorContrastIssuesInSession, isMediaAltCross ? undefined : pageId);
    return specificPageResults;
  }, [crossPageColorContrastIssuesInSession, isMediaAltCross]);
};
//# sourceMappingURL=use-build-specific-page-issue-results.js.map